import { useMemo } from 'react';
import { SerializedAccountForList } from 'fym-common/src/db/serializersTypes';
import { useGetAccountsQuery } from '../../redux/api/fymAPI';
import { useAccountId, useUserToken } from '../../redux/slices/appInfo/hooks';
import { withoutDemoAccounts } from './demoAccounts';

export interface WorkspaceArtists {
  /** The own artists of the workspace, without the demo artist. Empty while the list loads. */
  ownAccounts: SerializedAccountForList[];
  /** The active artist, the demo artist included. */
  active: SerializedAccountForList | undefined;
  /** The artist list of the workspace has loaded. */
  isLoaded: boolean;
}

/** The artists of the active workspace, for the account card and the page-bar artist pill. */
export function useWorkspaceArtists(): WorkspaceArtists {
  const userToken = useUserToken();
  const activeAccountId = useAccountId();
  const { accounts } = useGetAccountsQuery(undefined, {
    skip: !userToken,
    selectFromResult: ({ data }) => ({ accounts: data?.accounts }),
  });

  return useMemo(() => {
    const ownAccounts = withoutDemoAccounts(accounts ?? []);
    const active = accounts?.find((account) => account.id === activeAccountId);
    return { ownAccounts, active, isLoaded: accounts !== undefined };
  }, [accounts, activeAccountId]);
}
